import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "package" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, "Build v" + _toDisplayString(_ctx.VERSION), 1),
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packages, (version, name) => {
        return (_openBlock(), _createElementBlock("li", { key: version }, [
          _createTextVNode(_toDisplayString(name) + " ", 1),
          _createElementVNode("b", null, "v" + _toDisplayString(_ctx.cleanVersion(version)), 1)
        ]))
      }), 128))
    ])
  ]))
}